"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireService = void 0;
class QuestionnaireService {
    /**
     * This function is used to get the boolean value of a question
     * @param {string} qId  - question id.
     * @param {object} questionnaire  - questionnaire object.
     * @returns {boolean} The boolean value of the specified question.
     */
    static checkBooleanQuestionValue = ({ qId, questionnaire }) => {
        const booleanAsString = questionnaire?.questions.find((q) => q.questionId && q.questionId.toString().includes(qId))?.value;
        const result = booleanAsString == '$_BOOL_true';
        return result;
    };
    /**
     * This function is used to filter out sections that are not relevant to the current flow (MTA/Renewal vs user flow)
     * @param {string} key  - section name
     * @param {boolean} isMTAorRenewal  - true if the current flow is MTA or Renewal
     * @returns {boolean} true if the section should be included in the current flow, false otherwise.
     */
    static includeSection = ({ key, isMTAorRenewal }) => {
        const sectionsToExcludeFromUserFlow = ['S_MTA_Coverages'];
        const sectionsToExcludeFromMTAandRenewalFlow = ['S_Summary_Details', 'S_Pricing'];
        return isMTAorRenewal ? !sectionsToExcludeFromMTAandRenewalFlow.includes(key) : !sectionsToExcludeFromUserFlow.includes(key);
    };
    /**
     * This function is used to construct the layoutGrouping based on the flow (MTA/Renewal vs user flow)
     * @param {object} questionnaire  - questionnaire object.
     * @param {boolean} isMTAorRenewal  - true if the current flow is MTA or Renewal.
     * @returns {Record<string, LayoutBlock[]>} The layoutGrouping object.
     */
    static setLayoutGrouping = ({ questionnaire, isMTAorRenewal }) => {
        const layoutGrouping = {};
        if (questionnaire?.layoutGrouping) {
            Object.entries(questionnaire?.layoutGrouping).forEach(([key, value]) => {
                if (QuestionnaireService.includeSection({ key, isMTAorRenewal })) {
                    layoutGrouping[key] = value;
                }
            });
        }
        return layoutGrouping;
    };
    /**
     * This function is used to construct the sections array based on the flow (MTA/Renewal vs user flow)
     * @param {boolean} isMTAorRenewal  - true if the current flow is MTA or Renewal.
     * @param {object} questionnaire  - questionnaire object.
     * @returns {Array} The sections array.
     */
    static setSections = ({ questionnaire, isMTAorRenewal }) => {
        return questionnaire?.sections.map((sg) => sg.filter((s) => QuestionnaireService.includeSection({ key: s, isMTAorRenewal })));
    };
    /**
     * This function determines if the current flow is MTA/Renewal.
     * @param {object} questionnaire  - questionnaire object.
     * @returns {boolean} true if the questionnaire is MTA or Renewal, false otherwise.
     */
    static getIsMTAorRenewal = ({ questionnaire }) => {
        const [isMTA, isRenewal] = ['Is_MTA', 'Is_Renewal'].map(qId => QuestionnaireService.checkBooleanQuestionValue({ qId, questionnaire }));
        const isMTAorRenewal = isMTA || isRenewal;
        return isMTAorRenewal;
    };
}
exports.QuestionnaireService = QuestionnaireService;
